module.exports = __webpack_public_path__ + "img/1505434775.bda89ac8.jpg";